module.exports = __webpack_public_path__ + "static/media/Clothify.056e4b2e.jpg";